var map = {
	"./ambassador-1.png": "e537",
	"./ambassador-2.png": "217a",
	"./banner-affordable-and-clean-energy.png": "96e6",
	"./banner-clean-water.png": "d7b6",
	"./banner-climate-actions.png": "7d28",
	"./banner-decent-work-and-economy-growth.png": "5c7b",
	"./banner-gender-equality.png": "cc5c",
	"./banner-good-health-and-well-being.png": "b2a8",
	"./banner-industry-innovation-infrastructure.png": "0a15",
	"./banner-life-bellow-water.png": "207f",
	"./banner-life-on-land.png": "24f6",
	"./banner-mask.svg": "ff1a",
	"./banner-no-poverty.png": "cf3b",
	"./banner-partnerships-for-the-goals.png": "6edf",
	"./banner-peace-justice-and-strong-instituitions.png": "acb9",
	"./banner-quality-education.png": "1170",
	"./banner-reduced-inequalities.png": "855f",
	"./banner-responsible-consumption-and-production.png": "282c",
	"./banner-sustainable-cities-and-communities.png": "c1e7",
	"./banner-zero-hunger.png": "dbdd",
	"./categories.png": "bd3b",
	"./goal-eight-br.png": "d664",
	"./goal-eight-en.png": "5adf",
	"./goal-eighteen-br.png": "17fc",
	"./goal-eighteen-en.png": "b747",
	"./goal-eleven-br.png": "9541",
	"./goal-eleven-en.png": "8cf2",
	"./goal-fifteen-br.png": "98d2",
	"./goal-fifteen-en.png": "6df3",
	"./goal-five-br.png": "1be9",
	"./goal-five-en.png": "e7ac",
	"./goal-four-br.png": "0a14",
	"./goal-four-en.png": "ee57",
	"./goal-fourteen-br.png": "ce17",
	"./goal-fourteen-en.png": "1673",
	"./goal-nine-br.png": "119a",
	"./goal-nine-en.png": "2e52",
	"./goal-one-br.png": "8a16",
	"./goal-one-en.png": "2043",
	"./goal-seven-br.png": "2293",
	"./goal-seven-en.png": "f40b",
	"./goal-seventeen-br.png": "08e6",
	"./goal-seventeen-en.png": "e432",
	"./goal-six-br.png": "5d1e",
	"./goal-six-en.png": "0dc3",
	"./goal-sixteen-br.png": "303e",
	"./goal-sixteen-en.png": "8ebf",
	"./goal-ten-br.png": "b210",
	"./goal-ten-en.png": "fe81",
	"./goal-thirteen-br.png": "a046",
	"./goal-thirteen-en.png": "13cf",
	"./goal-three-br.png": "d0bc",
	"./goal-three-en.png": "00c9",
	"./goal-twelve-br.png": "8c2e",
	"./goal-twelve-en.png": "0ffe",
	"./goal-two-br.png": "1e51",
	"./goal-two-en.png": "10cf",
	"./sdg-onu-br.png": "864b",
	"./sustain-development-br.png": "2888",
	"./sustain-development.png": "d70b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c849";